import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MENU } from 'src/app/layouts/sidebar/menu';
import { MenuItem } from 'src/app/layouts/sidebar/menu.model';
@Component({
	selector: 'app-permissions',
	templateUrl: './permissions.component.html',
	styleUrls: ['./permissions.component.scss'],
})
export class PermissionsComponent implements OnInit {
	menuItems: MenuItem[] = [];
	selectedView: MenuItem;

	constructor(public translate: TranslateService,) {
		this.menuItems = MENU;
		// La primera vista del menú queda seleccionada al entrar.
		this.selectedView = MENU.find((item) => !item.isTitle && !item.isLayout && !item.subItems?.length);
	}

	ngOnInit(): void {}

	onViewSelect(view: MenuItem) {
		this.selectedView = view;
	}
}
